<div class="alert"
     [ngClass]="{
        'alert--positive': type === 'positive',
        'alert--negative': type === 'negative',
        'alert--warning': type === 'warning',
        'alert--info': type === 'info' || !type,
        'alert--centered': iconCentered
      }"
     >
  <icon *ngIf="iconVisible" class="icon"
        [src]="type === 'positive' ? 'assets/img/alert/positive.svg'
         : type === 'negative' ? 'assets/img/alert/negative.svg'
          : type === 'warning' ? 'assets/img/alert/warning.svg'
           : 'assets/img/alert/info.svg'"
        width="20px"
        height="20px"
  ></icon>
  <div class="text">
    <div *ngIf="title" class="text-title" [translate]="title"></div>
    <div *ngIf="description" class="text-description" [innerHTML]="description | translate"></div>
    <ng-content></ng-content>
  </div>
</div>
